import { Box } from "@mui/material";
import { Header } from "./Header";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import { WagmiProvider, createConfig } from "wagmi";
import { mainnet, sepolia } from "wagmi/chains";
import { http } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import MetaDataUpdater from "../component/MetaDataUpdater";

const queryClient = new QueryClient();
const wagmiConfig = createConfig({
  chains: [mainnet, sepolia],
  transports: {
    [mainnet.id]: http(),
    [sepolia.id]: http(),
  },
});

const MainLayout = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh", // full height of viewport
      }}
    >
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <Header />
        </QueryClientProvider>
      </WagmiProvider>
      <MetaDataUpdater />
      <Box
        component={"main"}
        sx={{
          flex: 1, // this makes the main area grow to fill space
        }}
      >
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
};
export default MainLayout;
